// @ts-nocheck
import React, { useEffect, useState } from 'react'
// Component
import { DivFlex } from '../../../../components/Common/CellText'
// Style Component
import { LableItem } from './PopupHandleDocumentIncomingStyled'
// Ant design
import { BankOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  message,
  Modal,
  Row,
  Select,
  Space,
  Tag,
  Tooltip,
} from 'antd'
// Mobx
import { inject, observer } from 'mobx-react'
// Other
import moment from 'moment'
import { blue, yellowPrimary } from '../../../../color'
import { AvatarHasName } from '../../../../components/Common/Avatar'
import SelectGroupPopupDocument from '../../../../components/SelectGroupPopup/SelectGroupPopupDocument'
import SelectPeoplePopupDocument from '../../../../components/SelectPeoplePopup/SelectPeoplePopupDocument'
import {
  ASSIGNEE_TYPE,
  DATE_FORMAT_LIST,
  INTERNAL_DOCUMENT_INCOMING_STATUS,
} from '../../../../constants'
import ListHistoryLogStore from '../../../ListHistoryLog/ListHistoryLogStore'
import { SelectList } from '../../../MissionCreatePage/MissionCreatePageStyled'

const { Option } = Select

const PopupHandleDocumentIncoming = props => {
  const {
    internalDocumentStore,
    loadingAnimationStore,
    selectPeopleStore,
    currentUser,
  } = props

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    originDepartmentWithUserList,
    clearSelected,
  } = selectPeopleStore

  const {
    selectedInternalDocumentIncoming,
    userAssignList,
    departmentAssignList,
    groupAssignList,
  } = internalDocumentStore

  const {
    end_date,
    start_date,
    document_status,
    date_issued,
  } = selectedInternalDocumentIncoming

  const {
    isVisiblePopupHandleDocument,
    handleCloseHandleDocument,
    handleCancelHandleDocument,
  } = props

  const [handlerList, setHandlerList] = useState([])
  const [combinerList, setCombinerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  useEffect(() => {
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setCombinerList([
      ...selectUserData[ASSIGNEE_TYPE.COMBINER],
      ...selectDepartmentData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
    ])
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const handleSubmit = async () => {
    const new_items_assign = []
    const remove_items_assign = []
    const listAssignOrigin = [
      ...userAssignList,
      ...departmentAssignList,
      ...groupAssignList,
    ].map(el => ({
      assignee_code: el.assignee_code,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))

    const listAssignAfter = [
      ...followerList,
      ...handlerList,
      ...combinerList,
    ].map(el => ({
      assignee_code: el.id,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))

    listAssignAfter.forEach(assignAfter => {
      if (
        !listAssignOrigin.some(
          assignOrigin =>
            assignOrigin.assignee_code + assignOrigin.permission ===
            assignAfter.assignee_code + assignAfter.permission
        )
      ) {
        new_items_assign.push({
          assignee_code: assignAfter.assignee_code,
          assignee_type: assignAfter.assignee_type,
          permission: assignAfter.permission,
        })
      }
    })

    listAssignOrigin.forEach(assignOrigin => {
      if (
        !listAssignAfter.some(
          assignAfter =>
            assignAfter.assignee_code + assignAfter.permission ===
            assignOrigin.assignee_code + assignOrigin.permission
        )
      ) {
        remove_items_assign.push({
          assignee_code: assignOrigin.assignee_code,
          assignee_type: assignOrigin.assignee_type,
          permission: assignOrigin.permission,
        })
      }
    })

    const dataSubmit = {
      new_items: new_items_assign,
      remove_items: remove_items_assign,
      start_date: valueInput.start_date,
      end_date: valueInput.end_date,
      document_status: valueInput.document_status,
    }

    loadingAnimationStore.showSpinner(true)

    try {
      // Gửi yêu cầu cập nhật dữ liệu lên server
      await internalDocumentStore.updateAssignees(
        selectedInternalDocumentIncoming.code,
        dataSubmit
      )

      // Làm mới dữ liệu từ server
      await internalDocumentStore.getInternalDocumentIncomingById(
        selectedInternalDocumentIncoming.code
      )
      await ListHistoryLogStore.getLists(selectedInternalDocumentIncoming.code)
      handleCloseHandleDocument()
      message.success('Xử lý văn bản thành công!')
    } catch (err) {
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      // Tắt spinner sau khi quá trình xử lý hoàn tất
      loadingAnimationStore.showSpinner(false)
    }
  }

  const [valueInput, setValueInput] = useState({
    start_date: null,
    end_date: null,
    document_status: null,
  })

  useEffect(() => {
    if (!isVisiblePopupHandleDocument) return

    if (
      selectUserData[ASSIGNEE_TYPE.COMBINER].length === 0 &&
      selectUserData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectUserData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectUserData(
        selectPeopleStore.convertSelectDataObj(userAssignList)
      )
    }

    if (
      selectDepartmentData[ASSIGNEE_TYPE.COMBINER].length === 0 &&
      selectDepartmentData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectDepartmentData(
        selectPeopleStore.convertSelectDataObj(departmentAssignList)
      )
    }

    if (
      selectGroupData[ASSIGNEE_TYPE.COMBINER].length === 0 &&
      selectGroupData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectGroupData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectGroupData(
        selectPeopleStore.convertSelectDataObj(groupAssignList)
      )
    }

    setValueInput({
      start_date: start_date,
      end_date: end_date,
      document_status: document_status,
      // document_status !== INTERNAL_DOCUMENT_INCOMING_STATUS.INPROGRESS
      //   ? document_status
      //   : null,
    })
  }, [
    selectedInternalDocumentIncoming,
    isVisiblePopupHandleDocument,
    originDepartmentWithUserList,
  ])

  const disabledEndDate = endValue => {
    const startValue = valueInput.start_date
    if (!startValue || !endValue) {
      return false
    }
    return endValue.isBefore(startValue, 'day')
  }

  const onCancelModal = () => {
    handleCancelHandleDocument()
    clearSelected()
  }

  return (
    <Modal
      onCancel={onCancelModal}
      maskClosable={false}
      footer={null}
      width={900}
      title="Xử lý văn bản"
      wrapClassName="custom-modal-wrapper"
      visible={isVisiblePopupHandleDocument}>
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <LableItem>Trạng thái văn bản:</LableItem>
          <Select
            placeholder={'Trạng thái'}
            style={{ width: '100%' }}
            value={valueInput.document_status}
            onChange={value =>
              setValueInput({ ...valueInput, document_status: value })
            }>
            <Option value={INTERNAL_DOCUMENT_INCOMING_STATUS.PENDING}>
              Chưa xử lý
            </Option>
            <Option value={INTERNAL_DOCUMENT_INCOMING_STATUS.INPROGRESS}>
              Đã bút phê
            </Option>
            <Option value={INTERNAL_DOCUMENT_INCOMING_STATUS.COMPLETE}>
              Hoàn thành
            </Option>
          </Select>
        </Col>
        <Col span={8}>
          <LableItem>Ngày bắt đầu:</LableItem>
          <DatePicker
            style={{ width: '100%' }}
            format={DATE_FORMAT_LIST}
            value={valueInput.start_date ? moment(valueInput.start_date) : null} // Chuyển thành moment nếu có ngày, nếu không thì null
            onChange={date => {
              // Nếu người dùng bỏ chọn, set lại giá trị thành null
              setValueInput(prev => ({
                ...prev,
                start_date: date ? date : null, // Nếu chọn ngày, gán giá trị; nếu không, gán null
              }))
            }}
          />
        </Col>
        <Col span={8}>
          <LableItem>Ngày kết thúc:</LableItem>
          <DatePicker
            style={{ width: '100%' }}
            format={DATE_FORMAT_LIST}
            value={valueInput.end_date ? moment(valueInput.end_date) : null} // Chuyển thành moment nếu có ngày, nếu không thì null
            onChange={date => {
              // Nếu người dùng bỏ chọn, set lại giá trị thành null
              setValueInput(prev => ({
                ...prev,
                end_date: date ? date : null, // Nếu chọn ngày, gán giá trị; nếu không, gán null
              }))
            }}
            disabledDate={disabledEndDate}
          />
        </Col>
        <Col span={8}>
          <DivFlex margin={'0 0 15px'}>
            <LableItem>Lãnh đạo xử lý:</LableItem>
            <Space>
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  className="select-user-icon-btn"
                  icon={<UserOutlined style={{ color: blue }} />}
                  onClick={() =>
                    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.HANDLER)
                  }
                />
              </Tooltip>
            </Space>
          </DivFlex>
          <SelectList>
            {handlerList.map(el => (
              <Tag
                className={'tag-selected'}
                color={'blue'}
                key={el.id}
                closable
                onClose={() => {
                  // Kiểm tra nếu currentUser có department.code là 'VT'
                  if (currentUser?.department?.code === 'VT') {
                    selectPeopleStore.handleRemoveSelect(el)
                  } else {
                    // Hiển thị thông báo bằng message
                    message.error('Chỉ nhân viên văn thư mới được quyền xoá', 5)
                  }
                }}>
                <AvatarHasName
                  imgId={el.image_id}
                  size={22}
                  name={el.full_name}
                  icon={
                    (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                      <BankOutlined />
                    )) ||
                    (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                      <TeamOutlined />
                    ))
                  }
                />
              </Tag>
            ))}
          </SelectList>
        </Col>
        <Col span={8}>
          <DivFlex margin={'0 0 15px'}>
            <LableItem>Người xử lý:</LableItem>
            <Space>
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  className="select-user-icon-btn"
                  icon={<UserOutlined style={{ color: blue }} />}
                  onClick={() =>
                    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.COMBINER)
                  }
                />
              </Tooltip>
              <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                <Button
                  className="select-user-icon-btn"
                  icon={<TeamOutlined />}
                  style={{ color: yellowPrimary }}
                  onClick={() =>
                    handleOpenSelectGroupPopup(ASSIGNEE_TYPE.COMBINER)
                  }
                />
              </Tooltip>
            </Space>
          </DivFlex>
          <SelectList>
            {combinerList.map(el => (
              <Tag
                className={'tag-selected'}
                color={'blue'}
                key={el.id}
                closable
                onClose={() => {
                  // Kiểm tra nếu currentUser có department.code là 'VT'
                  if (currentUser?.department?.code === 'VT') {
                    selectPeopleStore.handleRemoveSelect(el)
                  } else {
                    // Hiển thị thông báo bằng message
                    message.error('Chỉ nhân viên văn thư mới được quyền xoá', 5)
                  }
                }}>
                <AvatarHasName
                  imgId={el.image_id}
                  size={22}
                  name={el.full_name}
                  icon={
                    (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                      <BankOutlined />
                    )) ||
                    (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                      <TeamOutlined />
                    ))
                  }
                />
              </Tag>
            ))}
          </SelectList>
        </Col>
        <Col span={8}>
          <DivFlex margin={'0 0 15px'}>
            <LableItem>Phối hợp/ Theo dõi:</LableItem>
            <Space>
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  className="select-user-icon-btn"
                  icon={<UserOutlined style={{ color: blue }} />}
                  onClick={() =>
                    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.FOLLOWER)
                  }
                />
              </Tooltip>
              <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                <Button
                  className="select-user-icon-btn"
                  icon={<TeamOutlined />}
                  style={{ color: yellowPrimary }}
                  onClick={() =>
                    handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)
                  }
                />
              </Tooltip>
            </Space>
          </DivFlex>
          <SelectList>
            {followerList.map(el => (
              <Tag
                className={'tag-selected'}
                color={'blue'}
                key={el.id}
                closable
                onClose={() => {
                  // Kiểm tra nếu currentUser có department.code là 'VT'
                  if (currentUser?.department?.code === 'VT') {
                    selectPeopleStore.handleRemoveSelect(el)
                  } else {
                    // Hiển thị thông báo bằng message
                    message.error('Chỉ nhân viên văn thư mới được quyền xoá', 5)
                  }
                }}>
                <AvatarHasName
                  imgId={el.image_id}
                  size={22}
                  name={el.full_name}
                  icon={
                    (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                      <BankOutlined />
                    )) ||
                    (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                      <TeamOutlined />
                    ))
                  }
                />
              </Tag>
            ))}
          </SelectList>
        </Col>
      </Row>

      <div className="custom-modal-footer">
        <Button
          danger
          className="custom-ant-button w-160"
          onClick={onCancelModal}>
          Hủy bỏ
        </Button>
        <Button
          type={'primary'}
          onClick={handleSubmit}
          className="custom-ant-button w-160">
          Đồng ý
        </Button>
      </div>

      <SelectPeoplePopupDocument
        onlyOneUser={
          selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.HANDLER
        }
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        currentUser={currentUser}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <SelectGroupPopupDocument
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        currentUser={currentUser}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />
    </Modal>
  )
}

PopupHandleDocumentIncoming.propTypes = {}

export default inject(
  'internalDocumentStore',
  'loadingAnimationStore',
  'selectPeopleStore'
)(observer(PopupHandleDocumentIncoming))
